<template>
  <form @submit.prevent="submitForm" class="">
    <input type="hidden" name="" value="" />
    <div class="bg-white mb-2">
      <div class="form-shadow">
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group" id="sells-s">
              <label>Name</label>
              <Field type="text" class="form-control rounded-0 sel-control" v-model="formData.name" placeholder="Enter Your Name" name="name"></Field>
              <ErrorMessage name="name" class="error" />
            </div>
          </div>
          <div class="col-lg-12" id="sells-s">
            <div class="form-group">
              <label>Mobile Number</label>
              <Field type="text" class="form-control rounded-0 sel-control" v-model="formData.mobile" placeholder="Enter Your mobile Number" name="mobile"></Field>
              <ErrorMessage name="mobile" class="error" />
            </div>
          </div>
          <div class="col-lg-12" id="sells-s">
            <div class="form-group">
              <label>Email Address</label>
              <Field type="email" class="form-control rounded-0 sel-control" v-model="formData.email" placeholder="Enter Your Email" name="email"></Field>
              <ErrorMessage name="email" class="error" />
            </div>
          </div>
          <div class="col-12-6" id="sells-s">
            <!-- <div class="form-group">
                <label>Password</label>
                <Field type="password" class="form-control rounded-0 sel-control" v-model="formData.password" placeholder="Enter Your Password" name="password" ></Field>
                <ErrorMessage name="password" class="error" />
              </div> -->

            <label>Enter PIN</label>

              <div class="row justify-content-center">
                <div class="col-lg-12" id="sells-s">
                  <div class="otp-number">
                    <div class="form-group">
                      <input
                        type="tel"
                        class="form-control rounded-0 otp-control"
                        placeholder=""
                        min="1"
                        max="1"
                        name="numericInput1"
                        v-model="pinInput1"
                        @input="moveToNext(1)"
                      >
                      <span class="text-danger"></span>
                    </div>
                    <div class="form-group">
                      <input
                        type="tel"
                        class="form-control rounded-0 otp-control"
                        placeholder=""
                        min="1"
                        max="1"
                        name="numericInput2"
                        v-model="pinInput2"
                        @input="moveToNext(2)"
                      >
                      <span class="text-danger"></span>
                    </div>
                    <div class="form-group">
                      <input
                        type="tel"
                        class="form-control rounded-0 otp-control"
                        placeholder=""
                        min="1"
                        max="1"
                        name="numericInput3"
                        v-model="pinInput3"
                        @input="moveToNext(3)"
                      >
                      <span class="text-danger"></span>
                    </div>
                    <div class="form-group">
                      <input
                        type="tel"
                        class="form-control rounded-0 otp-control"
                        placeholder=""
                        min="1"
                        max="1"
                        name="numericInput4"
                        v-model="pinInput4"
                      >
                      <span class="text-danger"></span>
                    </div>
                    <ErrorMessage name="password" class="error" />
                  </div>
                </div>
              </div>
          </div>
          <div class="col-12-6" id="sells-s">
            <div class="form-group">
              <label>Address</label>
              <Field class="form-control rounded-0 sel-control" v-model="formData.address" placeholder="Enter Your address" name="address"></Field>
              <ErrorMessage name="address" class="error" />
            </div>
          </div>
          <div class="custom-control custom-checkbox mr-sm-2">
            <input type="checkbox" name="remember" class="custom-control-input" id="remember" v-model="formData.agree" required />
            <label class="custom-control-label" for="remember"
              >I agree to RC-PET <a :href="termsOfServiceRoute"><span class="terms-text">Terms of Service</span></a>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center">
      <button type="submit" class="btn btn-primary fw-600 rounded-0 reg-btn">SIGN UP</button>
    </div>
    <div class="already-text">
      <p>Already have a RC Pet Resort account?</p>
      <a href="login"><span> Log in</span></a>
    </div>
  </form>
</template>

<script setup>
import { ref } from 'vue'
import * as yup from 'yup'
import { useForm, Field, ErrorMessage } from 'vee-validate'
import axios from 'axios'
import { register, login } from '../constant/auth.js'

const validationSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
  mobile: yup
    .string()
    .required('Mobile number is required')
    .matches(/^\d{10}$/, 'Mobile number must be exactly 10 digits'),
  email: yup.string().email('Invalid email').required('Email is required'),
  // password: yup
  //   .string()
  //   .required('Password is required')
  //   .matches(/^\d{4}$/, 'Password must be exactly 4 digits'),
  address: yup.string().required('Address is required')
})
const { termsOfServiceRoute } = defineProps(['termsOfServiceRoute'])
const { handleSubmit: veeHandleSubmit, errors } = useForm({
  validationSchema,
  initialValues: {
    name: '',
    mobile: '',
    email: '',
    password: '',
    address: '',
    agree: false
  }
})
const formData = ref({
  name: '',
  mobile: '',
  email: '',
  password: '',
  address: '',
  agree: false
})
const pinInput1 = ref('');
const pinInput2 = ref('');
const pinInput3 = ref('');
const pinInput4 = ref('');
function moveToNext(inputNumber) {
  switch (inputNumber) {
    case 1:
      if (pinInput1.value.length >= 1) {
        document.getElementsByName('numericInput2')[0].focus();
      }
      break;
    case 2:
      if (pinInput2.value.length >= 1) {
        document.getElementsByName('numericInput3')[0].focus();
      }
      break;
    case 3:
      if (pinInput3.value.length >= 1) {
        document.getElementsByName('numericInput4')[0].focus();
      }
      break;
    default:
      break;
  }
}
const registerRoute = register()
const { path, method } = registerRoute
const loginRoute = login()

const submitForm = veeHandleSubmit(async () => {
  try {
    const pin = pinInput1.value + pinInput2.value + pinInput3.value + pinInput4.value;
    formData.value.password = pinInput1.value + pinInput2.value + pinInput3.value + pinInput4.value;
    const response = await axios.post(path, formData.value)

    if (response) {
      console.log(response.data.status)

      if (response.data.status == 400) {
        window.errorSnackbar(response.data.message)
        errors.value.email = response.data.message
        return
      }

      if (response.data.status == 400) {
        window.errorSnackbar(response.data.message)
        errors.value.mobile = response.data.message
        return
      }
      window.location.href = loginRoute.form
      window.successSnackbar('Registered Successfully')
    }
  } catch (error) {
    console.log(error)
  }
})
</script>
<style scoped>
.error {
  color: red;
}
</style>
